import { ThemeOptions } from '@melio/penny';

import {
  Bank,
  BankMissing,
  BankSuccess,
  Blocked,
  Celebration,
  Declined,
  Expired,
  MoneySuccess,
  NetworkError,
  NewEmail,
  NoItems,
  PageNotFound,
  PayZero,
  Pending,
  Processing,
  Sent,
  Success,
  SyncUser,
  TaxForm,
  VendorAdd,
} from './illustrations';
import { Spinner } from './loader';
import { CapOneLogo, CapOneLogoDark } from './logos';

export const capOneTheme: ThemeOptions = {
  loader: Spinner,
  logos: {
    light: CapOneLogo,
    dark: CapOneLogoDark,
  },
  fonts: {
    primary: 'Optimist',
  },
  textStyles: {
    heading3Semi: {
      fontSize: { s: '22px' },
      lineHeight: { s: '32px' },
    },
    body1Semi: {
      fontSize: { s: '22px' },
      lineHeight: { s: '32px' },
    },
    body1: {
      fontSize: { s: '22px' },
      lineHeight: { s: '32px' },
    },
    body2Semi: {
      fontSize: { s: '18px' },
    },
    body2: {
      fontSize: { s: '18px' },
    },
    body3Semi: {
      fontSize: { s: '16px' },
      lineHeight: { s: '24px' },
    },
    body3: {
      fontSize: { s: '16px' },
      lineHeight: { s: '24px' },
    },
    body4Semi: {
      fontSize: { s: '14px' },
      lineHeight: { s: '20px' },
    },
    body4: {
      fontSize: { s: '14px' },
      lineHeight: { s: '20px' },
    },
    body4SemiUpper: {
      fontSize: { s: '14px' },
      lineHeight: { s: '20px' },
    },
    body5SemiUpper: {
      fontSize: { s: '12px' },
    },
    caption1Semi: {
      fontSize: { s: '12px' },
      lineHeight: { s: '16px' },
    },
    caption1: {
      fontSize: { s: '12px' },
      lineHeight: { s: '16px' },
    },
    caption1SemiUpper: {
      fontSize: { s: '12px' },
      lineHeight: { s: '16px' },
    },
    caption2Semi: {
      fontSize: { s: '10px' },
      lineHeight: { s: '16px' },
    },
    inline: {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      fontWeight: 'inherit',
    },
  },
  colors: {
    brand: {
      darkest: '#014E74',
      dark: '#026597',
      main: '#0276B1',
      light: '#598AAA',
      lighter: '#8AB0C7',
      lightest: '#EBF8FF',
    },
    warning: {
      lightest: '#FFF1D0',
      lighter: '#FFE7A7',
      main: '#F9C606',
      dark: '#E8AD11',
      darkest: '#011728',
    },
    success: {
      lightest: '#E9FCE4',
      lighter: '#DAE8D8',
      main: '#25810E',
      dark: '#1E6A0B',
      darkest: '#003903',
    },
    info: {
      lightest: '#EBF8FF',
      lighter: '#8AB0C7',
      main: '#0276B1',
      dark: '#026597',
      darkest: '#014E74',
    },
    critical: {
      lightest: '#FFF0F0',
      lighter: '#F8ADA4',
      main: '#D0021B',
      dark: '#B70002',
      darkest: '#A3282B',
    },
    neutral: {
      black: '#141414',
      darkest: '#515252',
      darker: '#676868',
      dark: '#AFB0AF',
      light: '#D7D7D7',
      lighter: '#E6E6E6',
      lightest: '#FAFAFA',
      white: '#FFFFFF',
    },
    decorative: {
      decorative1: '#FFF1D0',
      decorative2: '#C0E7F3',
      decorative3: '#B3CDDE',
      decorative4: '#98D5EC',
      decorative5: '#DAE8D8',
    },
    link: {
      rest: 'brand.main',
      hover: 'brand.dark',
      pressed: 'brand.darkest',
    },
    components: {
      nakedButton: {
        secondary: {
          default: { color: 'link.rest' },
          hover: { color: 'link.hover' },
          active: { color: 'link.pressed' },
        },
      },
    },
  },
  illustrations: {
    bank: Bank,
    'bank-success': BankSuccess,
    'bank-missing': BankMissing,
    blocked: Blocked,
    celebration: Celebration,
    declined: Declined,
    expired: Expired,
    pending: Pending,
    processing: Processing,
    'page-not-found': PageNotFound,
    success: Success,
    'money-success': MoneySuccess,
    'network-error': NetworkError,
    'no-items': NoItems,
    'pay-zero': PayZero,
    'vendor-add': VendorAdd,
    'new-email': NewEmail,
    'sync-user': SyncUser,
    'tax-form': TaxForm,
    sent: Sent,
  },
};
